/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_LinkedInputs */

const he_account_delivery_linked = /** @type {(inputs: Account_Delivery_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מקושר`)
};

const en_account_delivery_linked = /** @type {(inputs: Account_Delivery_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked`)
};

/**
* | output |
* | --- |
* | "Linked" |
*
* @param {Account_Delivery_LinkedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_linked = /** @type {((inputs?: Account_Delivery_LinkedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_LinkedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_linked(inputs)
	return en_account_delivery_linked(inputs)
});